{
  "electronicJournalHost": "https://transaction-lookup.{{ej_region}}.retailprinting-prod.nikecloud.com",
  "electronicJournalCnHost": "https://transaction-lookup.{{ej_region}}.c4c-retail-comm-svc-prod.nikecloud.com.cn",
  "oktaAuthorizeResource" : "/v1/prod/authorize",
  "oktaTokenResource": "/v1/prod/token",
  "receiptsHost": "https://generate-retail-labels-v1.retailprinting-prod.nikecloud.com",
  "storeviewsHost": "https://storeviews-regional-us-east-1.risedomain-prod.nikecloud.com"
}
